interface Gradient {
  bg: string;
  color: 'dark' | 'light';
}

export const GRADIENTS: Gradient[] = [
  {
    bg: 'linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #fad0c4 0%, #ffd1ff 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to right, #ffecd2 0%, #fcb69f 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to right, #ff8177 0%, #ff867a 0%, #ff8c7f 21%, #f99185 52%, #cf556c 78%, #b12a5b 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #ff9a9e 0%, #fecfef 99%, #fecfef 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #f6d365 0%, #fda085 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #fbc2eb 0%, #a6c1ee 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #fdcbf1 0%, #fdcbf1 1%, #e6dee9 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);',
    color: 'dark',
  },
  {
    bg: 'linear-gradient(120deg, #a6c0fe 0%, #f68084 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #fccb90 0%, #d57eeb 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #f093fb 0%, #f5576c 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);',
    color: 'dark',
  },
  {
    bg: 'linear-gradient(to right, #4facfe 0%, #00f2fe 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to right, #43e97b 0%, #38f9d7 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to right, #fa709a 0%, #fee140 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #30cfd0 0%, #330867 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #a8edea 0%, #fed6e3 100%);',
    color: 'dark',
  },
  {
    bg: 'linear-gradient(to top, #5ee7df 0%, #b490ca 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #d299c2 0%, #fef9d7 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);',
    color: 'dark',
  },
  {
    bg: 'radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);',
    color: 'dark',
  },
  {
    bg: 'linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #fddb92 0%, #d1fdff 100%);',
    color: 'dark',
  },
  {
    bg: 'linear-gradient(to top, #9890e3 0%, #b1f4cf 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #ebc0fd 0%, #d9ded8 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #96fbc4 0%, #f9f586 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(180deg, #2af598 0%, #009efd 100%);',
    color: 'light',
  },
  {
    bg: 'linear-gradient(to top, #cd9cf2 0%, #f6f3ff 100%);',
    color: 'light',
  },
];
